module.exports = __webpack_public_path__ + "img/50400.8d7895cb.jpg";